import React from 'react';

import Skeletor from '../Skeletor';

const SkeletorButton = props => (
	<Skeletor height={40} width={150} display="inline-block" {...props} />
);

export default SkeletorButton;
